import { useEffect, useRef } from "react";

import { css } from "@compiled/react";

const containerStyles = css({
    "position": "absolute",
    "inset": 0,
    "overflow": "hidden",
    "pointerEvents": "none",
    "&::before": {
        content: '""',
        position: "absolute",
        zIndex: -2,
        inset: 0,
        background: `linear-gradient(to right, rgb(235 235 235) 0 2px, rgb(235 235 235 / 0) 1px 10px),
        linear-gradient(to bottom, rgb(235 235 235) 0 2px, rgb(235 235 235 / 0) 1px 10px)`,
        backgroundSize: "40px 2px, 2px 40px",
        backgroundPosition: "-2px -2px"
    },
    "&::after": {
        content: '""',
        position: "absolute",
        zIndex: -1,
        inset: 0,
        background: `radial-gradient(
                circle at var(--graph-grid-x, 50%) var(--graph-grid-y, 50%), 
                hsl(0 0% 100% / 0) min(5vmin,50px), 
                hsl(0 0% 100%) min(30vmin,300px)
            )`
    }
});

const UniformGraphPaperReveal = () => {
    const ref = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const spotlight = ref.current;
        const parent = spotlight?.parentElement;

        function move(e: PointerEvent) {
            if (!parent) return;
            const rect = parent.getBoundingClientRect();
            spotlight?.style.setProperty(
                "--graph-grid-x",
                e.clientX - rect.left + "px"
            );
            spotlight?.style.setProperty(
                "--graph-grid-y",
                e.clientY - rect.top + "px"
            );
        }

        if (window.PointerEvent) {
            parent?.addEventListener("pointermove", move, {
                passive: true
            });
        }

        return () => {
            parent?.removeEventListener("pointermove", move);
        };
    }, []);

    return <div css={containerStyles} ref={ref} />;
};

export default UniformGraphPaperReveal;
